module.exports = __webpack_public_path__ + "static/media/report.6d2a5e3d.svg";